/* eslint-disable */
import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import styled from 'styled-components';
import { TextLink } from '@oneaudi/unified-web-components';
import { SYS_SPACE_FIXED_350 } from '@oneaudi/unified-web-common';
import { messages } from '../../../i18n/messages';
import type { Action } from '../../../contexts/reducers/map-reducer';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import searchStateContext from '../../../contexts/map-context';

export const BackToResults = () => {
  const labelText = useI18n(messages.back_to_results);
  const dispatch = searchStateContext.useMapDispatch();
  const { selectedDealerId } = searchStateContext.useMapState();
  const onClickBackToResults = handleBackToResultsClick(dispatch);
  const ref = React.createRef<HTMLDivElement>();

  React.useEffect(() => {
    if (ref.current && selectedDealerId) {
      ref.current.scrollIntoView();
    }
  }, [selectedDealerId]);

  return selectedDealerId ? (
    <Container onClick={onClickBackToResults} ref={ref}>
      <TextLink iconPosition="leading" icon="back" href="#" variant="standalone" size="md">
        {labelText}
      </TextLink>
    </Container>
  ) : null;
};

const handleBackToResultsClick = (dispatch: React.Dispatch<Action>) => () => {
  dispatch({ type: ActionTypes.setSelectedDealerId, payload: null });
  dispatch({ type: ActionTypes.setDealerReviews, payload: [] });
  dispatch({ type: ActionTypes.setRatingSummary, payload: null });
};

const Container = styled.div.attrs({ 'data-test-id': 'mobile-layout-back-to-results' })<{
  onClick: () => void;
}>`
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: ${SYS_SPACE_FIXED_350};

  a {
    text-decoration: none;
  }

  .back-to-results-button path {
    stroke: #333333;
  }
`;
